import {createRoot} from "react-dom/client";
import {StrictMode} from "react";
import {type KcContext, KcPage} from "./keycloak-theme/kc.gen";

const root = document.getElementById("root");
if (!root) {
  throw new Error("No #root element on the page");
}

createRoot(root).render(
  <StrictMode>
    {window.kcContext ? (
      <KcPage kcContext={window.kcContext}/>
    ) : (
      <div>Something went wrong.</div>
    )}
  </StrictMode>,
);

declare global {
  interface Window {
    kcContext?: KcContext;
  }
}
